import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListForWizzardProductsModule } from '@shared/core/components/lists/listsTypes/forWizzardProducts';
import { ButtonsModule } from '@shared/core/components/buttons';
import { BadgesModule } from '@shared/core/components/badges';
import { IndicatorsModule } from '@shared/core/components/indicators';
import { MenuFlowPagesDirectiveSharedModule } from '@shared/core/directives/menuFlowPages/menu-flow-pages.directive.shared.module';
import { WizzardHeaderModule } from '../../../wizzardHeader';

import { WizzardCollapsePageComponent } from './wizzard-collapse-page.shared.component';

@NgModule({
    declarations: [
        WizzardCollapsePageComponent
    ],
    imports: [
        CommonModule,
        WizzardHeaderModule,
        ListForWizzardProductsModule,
        BadgesModule,
        ButtonsModule,
        IndicatorsModule,
        MenuFlowPagesDirectiveSharedModule,
    ],
    exports: [
        WizzardCollapsePageComponent
    ],
})
export class WizzardCollapsePageModule { }
